import '../assets/css/userStatistics.css';
import Sidebar from '../components/Sidebar';
import Calendar from "../components/userStatistics/Calendar.js";
import GamesDone from '../components/userStatistics/GamesDone.js';
import ProgressCircle from '../components/userStatistics/ProgressCircle.js';

export default function Stats() {
    return (
        <div className="page-container">
            <Sidebar />

            <div className="content-container">
                <div className="statistics-container">
                    <div className="content">
                        
                        <GamesDone />

                        <div className="theme-revised stat-card">
                            <div className="title">
                                <h4>Thème le plus révisé</h4>
                                <span>Thème</span>
                                {/* <span><?= strtoupper($mostReviewedTheme) ?></span> */}
                            </div>
                        </div>

                        <div className="empty stat-card"></div>

                        <Calendar />

                        <div className="stat-datas stat-card">
                            {/* <div className="good-answers-test">
                                <div className="progress">
                                    <span className="progress-left">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <span className="progress-right">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <div className="progress-value">50%</div> 
                                    <div className="progress-value"><?= $lastSuccessRate ?>%</div>
                                </div>
                                <div className="text">
                                    <p>de bonnes réponses</p>
                                    <p className="specific">sur le test</p>
                                </div>
                            </div> */}
                            {/* <div className="speed">
                                <div className="progress">
                                    <span className="progress-left">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <span className="progress-right">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <div className="progress-value">100%</div> 
                                    <div className="progress-value"><?= $comparisonRate ?>%</div>
                                </div>
                                <div className="text">
                                    <p>plus rapide</p>
                                    <p className="specific">que le mois dernier</p>
                                </div>
                            </div> */}
                            {/* <div className="good-answers-month">
                                <div className="progress">
                                    <span className="progress-left">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <span className="progress-right">
                                        <span className="progress-bar"></span>
                                    </span>
                                    <div className="progress-value">0%</div> 
                                    <div className="progress-value"><?= max(0, 100 - $comparisonRate) ?>%</div>
                                </div>
                                <div className="text">
                                    <p>de bonnes réponses</p>
                                    <p className="specific">que le mois dernier</p>
                                </div>
                            </div> */}
                            <div className="good-answers-test">
                                <ProgressCircle percentage={50} />
                                <div className="text">
                                    <p>de bonnes réponses</p>
                                    <p className="specific">sur le test</p>
                                </div>
                            </div>
                            <div className="speed">
                                <ProgressCircle percentage={100} />
                                <div className="text">
                                    <p>plus rapide</p>
                                    <p className="specific">que le mois dernier</p>
                                </div>
                            </div>
                            <div className="good-answers-month">
                                <ProgressCircle percentage={33} />
                                <div className="text">
                                    <p>de bonnes réponses</p>
                                    <p className="specific">que le mois dernier</p>
                                </div>
                            </div>
                            
                        </div>

                    </div>
                </div>
            </div>
        </div>
    ); 
}